import { ReloadIcon } from '@/components/icons/fetch-error';
import { Button } from '@/components/shared/Button';

import cn from './styles.module.sass';

export const FetchError = () => {
    const handleReloadPage = () => {
        window.location.reload();
    };

    return (
        <div className={cn.container}>
            <h2>Сбой загрузки</h2>
            <Button onClick={handleReloadPage}>{ReloadIcon} Перезагрузить</Button>
        </div>
    );
};
